const host = process.env.NODE_ENV === 'development' ? '' : ''
// ? '/associateApi'

const api = {
  // 0, 对账单下拉菜单列表
  reconcileBill_dictMap: `${host}/api/partner/outside/platform/settlement/agent/supplier/common/dict/map`,

  // 1,对账单查询
  reconcileBill_billSearch: `${host}/api/partner/outside/platform/settlement/agent/supplier/bill/search`,

  // 2, 查看对账单详情
  reconcileBill_BillDetail: `${host}/api/partner/outside/platform/settlement/agent/supplier/bill/detail`,

  // 3,账单审核
  reconcileBill_billAudit: `${host}/api/partner/outside/platform/settlement/agent/supplier/bill/audit`,

  // 4,发票提交接口
  reconcileBill_invoiceSubmit: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/submit`,

  // 4, 批量提交发票接口
  reconcileBill_multiInvoicesRecoding: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/multiInvoicesRecoding`,

  // 5,通过对账单号获取付款单信息列表接口
  reconcileBill_listPayOrders: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/listPayOrders`,

  // 6,通过结算单号获取发票信息列表接口(验票信息)
  reconcileBill_listInvoicesByOrderId: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/listInvoicesByOrderId`,

  // 7,获取付款单pdf接口
  reconcileBill_billPrint: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/billPrint`,

  // 8,上传文件接口
  reconcileBill_upload: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/file/upload`,

  // 9,查询对账单抵扣明细
  reconcileBill_getDeductRecord: `${host}/api/partner/outside/platform/settlement/agent/ops/bill/getDeductRecord`,

  // 9.5,发票录入接口
  reconcileBill_inputInvoice: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/input`,

  // 10,发票验票接口
  reconcileBill_checkInvoice: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/check`,

  // 11,发票删除接口
  reconcileBill_deleteInvoice: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/delete`,

  // 12,提交发票接口
  reconcileBill_submitAfterCheck: `${host}/api/partner/outside/platform/settlement/agent/supplier/invoice/submitAfterCheck`,

  // 13,长春城投账单列表
  reconcileBill_changChunList: `${host}/api/partner/outside/platform/settlement/changchun/get/list`,

  // 14,长春城投导出
  reconcileBill_changChunExport: `${host}/api/partner/outside/platform/settlement/changchun/get/excel`,

  // 15,申请修改税率
  reconcileBill_modifyTax: `${host}/api/partner/outside/platform/modify/tax`,

  // 费用详情
  reconcileBill_billFee: `${host}/api/partner/outside/platform/ops/bill/fee`,

  // 申诉原因
  reconcileBill_appealReason: `${host}/api/partner/outside/platform/settlement/agent/supplier/bill/appeal/reason`,

  // 账单申诉
  reconcileBill_billAppeal: `${host}/api/partner/outside/platform/settlement/agent/supplier/bill/appeal`,

  // 申诉详情
  reconcileBill_appealDetail: `${host}/api/partner/outside/platform/settlement/partner/listOperationLogById`,

  reconcileBill_schoolExport: `${host}/api/partner/outside/platform/settlement/agent/supplier/xiaoyuan/excel`,

  reconcileBill_getInvoiceForm: `${host}/api/partner/outside/platform/global/config/getInvoiceForm`,

  // 16,放弃结算
  reconcileBill_giveUp: `${host}/api/partner/outside/platform/agent/abandon/settle`,

  // 识别发票后确定按钮
  reconcileBill_confirmInvoiceHella: `${host}/api/partner/outside/platform/invoice/upload/confirm`,

  // 发票提交
  reconcileBill_submitInvoiceHella: `${host}/api/partner/outside/platform/invoice/submit`,

  // 发票删除
  reconcileBill_deleteInvoiceHella: `${host}/api/partner/outside/platform/invoice/deleteInvoice`,

  // 获取已录入发票列表
  reconcileBill_getInvoiceHella: `${host}/api/partner/outside/platform/invoice/getInvoice`,

  // 获取付款单列表
  reconcileBill_getPayOrdersHella: `${host}/api/partner/outside/platform/invoice/getPayOrders`,

  // （公用）发起异步发票OCR
  uploadInvoiceFileHella: `${host}/api/partner/outside/platform/invoice/upload`,

  // （公用）查询OCR结果
  getInvoiceResultHella: `${host}/api/partner/outside/platform/invoice/queryOcrResult`,
}

export default api
